{
  "overview": "Overview",
  "dashboard": "Dashboard",
  "menuError": {
    "title": "Navigation unavailable",
    "description": "Could not load navigation rules. Refresh the page or try again later."
  },
  "console": {
    "title": "Console",
    "terminal-logs": "Terminal logs",
    "connection": "Connection"
  },
  "summary": "Summary",
  "srm": "SRM",
  "subscriptions": {
    "title": "Notifications",
    "my-subscriptions": "My subscriptions",
    "external-services": "External services",
    "message-templates": "Message Templates",
    "receivers": "Receivers",
    "userReceivers": "User receivers"
  },
  "changeRequest": "Change request",
  "access": {
    "title": "Access",
    "srm": "SRM",
    "healthIndicators": "Health indicators",
    "navigation": "Features",
    "dashboards": "Dashboards",
    "dashboardsV4": "Dashboards (ACL)",
    "tql": "TQL"
  },
  "users": {
    "title": "Users",
    "usersSessions": "Users sessions",
    "usersRegistry": "Users registry",
    "usersAuditLogs": "Audit logs"
  },
  "attacks": "Attacks",
  "main": "Main",
  "settings": {
    "title": "Settings",
    "srm": "SRM",
    "cit": "CI Types",
    "enrichment": "Enrichment",
    "enrichment-statistics": "Enrichment statistics",
    "enrichment-logs": "Enrichment logs",
    "actionPlans": "Action plans",
    "attributes": "Attributes",
    "monitoring": "Monitoring",
    "healthIndicators": "Health indicators",
    "monitoringSettings": "Jobs & Exporters",
    "content-pack": "Content pack",
    "prometheus": {
      "title": "Prometheus",
      "config": "Configuration",
      "alerts": "Alerts",
      "targets": "Targets",
      "exporters": "Exporters"
    },
    "users": "Users",
    "user": "Attributes",
    "ldap": "LDAP",
    "system": "System",
    "globalSettings": "Global settings",
    "schedules": "Scheduled tasks",
    "monitoringTemplates": "Monitoring templates",
    "vmAgents": "Metrics collection agents",
    "vmAlerts": "Rules processing agents",
    "s3": "S3 connectors",
    "plugins": "Plugins",
    "components": "Components",
    "notifications": {
      "title": "Notifications",
      "time-interval": "Time Intervals",
      "senders": "Senders",
      "receivers": "Receivers",
      "subscriptions": "Subscriptions"
    },
    "alertManager": "Alert Manager",
    "inhibitRules": "Inhibit rules",
    "notificationsGeneral": "General settings",
    "templates": "Templates",
    "license": "License",
    "ci-bulk-import": "CI import"
  },
  "breadcrumb": {
    "main": "Main",
    "subscriptions": {
      "title": "Notifications",
      "my-subscriptions": "My subscriptions",
      "external-services": "External services",
      "message-templates": "Message Templates",
      "receivers": "Receivers"
    },
    "settings": {
      "name": "Settings",
      "srm": "SRM",
      "cit": "CI Types",
      "enrichment": "CPM enrichment plans",
      "actionPlans": "Action plans",
      "attributes": "Attributes",
      "monitoring": "Мониторинг",
      "healthIndicators": "Health indicators",
      "monitoringSettings": "Jobs & Exporters",
      "prometheus": {
        "title": "Prometheus",
        "config": "Prometheus Configuration",
        "alerts": "Prometheus Alerts",
        "targets": "Prometheus Targets",
        "exporters": "Prometheus Exporters"
      },
      "users": "Users",
      "user": "Attributes",
      "ldap": "LDAP",
      "oidc": "OIDC",
      "system": "System",
      "globalSettings": "Global settings",
      "schedules": "Scheduled tasks",
      "components": "Components",
      "plugins": "Plugins",
      "license": "License",
      "ci-bulk-import": "CI import"
    },
    "srm": {
      "name": "Service and resource model"
    },
    "changeRequest": {
      "name": "Change requests"
    },
    "access": {
      "name": "Access",
      "healthIndicators": "Health indicators",
      "SRM": "SRM",
      "navigation": "Features",
      "dashboards": "Dashboards",
      "tql": "TQL"
    },
    "users": {
      "list": "Users",
      "usersSessions": "Users sessions",
      "usersRegistry": "Users registry",
      "profile": "Profile"
    },
    "attacks": {
      "name": "Attacks"
    },
    "devices": {
      "name": "Devices"
    },
    "notification": {
      "name": "Notification"
    }
  }
}
